/* eslint-disable */
import axios from 'axios'
import * as Sentry from '@sentry/react'
import {
  sessionStorageGetItem,
  sessionStorageSetItem,
} from '$func/session-storage'
import { LocalFind, LocalInsert } from '@weblite/persist'

const CLOCK_CHECK = 'clock-check'
const CLOCK_OFFSET = 'clock-offset'

const options = {
  checkInterval: 48 * 60 * 60 * 1000, // 2 days
  timeServer: import.meta.env.VITE_TIME_SERVER,
  tolerance: 5 * 60 * 1000, // 5 minutes
  dstStr: 'iran daylight',
}

const getServerOffset = async () => {
  if (!options.timeServer) return 0

  const { data } = await axios.get(options.timeServer)

  return Date.now() - +data * 1000
}

export const dateWithOffset = () => {
  return Date.now() - +(LocalFind(CLOCK_OFFSET) || 0)
}

export const hasClockOffset = async () => {
  // in milliseconds
  const offset = await getServerOffset()
  LocalInsert(CLOCK_OFFSET, offset.toString())
  const hasOffset = Math.abs(offset) > options.tolerance
  if (hasOffset) {
    Sentry.setTag('clock.offset', offset)
  }

  const dst = new Date().toString().toLowerCase().includes(options.dstStr)
  if (dst) {
    Sentry.setTag('clock.dst', true)
  }
  if (dst || hasOffset) {
    console.warn('clock', { dst, offset, hasOffset })
  }

  return dst || hasOffset
}

export const shouldShowClockDialog = async () => {
  const lastCheckTime = +(LocalFind(CLOCK_CHECK) || 0)

  if (
    LocalFind(CLOCK_OFFSET) &&
    Date.now() < lastCheckTime + options.checkInterval
  ) {
    return false
  }

  const shouldShow = hasClockOffset()
  LocalInsert(CLOCK_CHECK, Date.now().toString())
  return shouldShow
}
